import React from "react";
import { object } from "prop-types";
import { Link } from "@quintype/components";
import get from "lodash/get";

import ByName from "../../atoms/by-name";
import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import Placeholder from "../../atoms/icons/placeholder";

import "./blog-story-header.m.css";

const BlogStoryHeader = ({ story }) => {
  const sectionName = story.sections[0]["display-name"] || story.sections[0].name;
  const sectionSlug = story.sections[0]["slug"] || "";
  const authorId = story["author-id"] || "";
  const authorObj = get(story, ["authors", "0"], null);
  const authorObjId = (authorObj && authorObj.id) || authorId;
  const authorObjSlug = (authorObj && authorObj.slug) || "";
  const authorName = (authorObj && authorObj.name) || "";

  return (
    <div styleName="header-content">
      <Link href={`/${sectionSlug}`}>
        <Headline text={sectionName} headerType={9} headerLevel={2} />
      </Link>

      {story.headline && <Headline text={story.headline} headerType={1} headerLevel={2} />}

      {authorObj ? (
        <ByName
          name={authorName}
          id={authorObjId.toString()}
          authorSlug={authorObjSlug}
          date={story["first-published-at"]}
          sectionName={sectionName}
        />
      ) : null}

      {story["hero-image-s3-key"] ? (
        <CardImage
          story={story}
          defaultWidth={36}
          aspectRatio={[16, 9]}
          imageType="image16x9"
          widths={[250, 480, 764]}
        />
      ) : (
        <Placeholder />
      )}

      <div styleName="figure-caption">
        {story["hero-image-attribution"] && (
          <span styleName="image-attribute"> {story["hero-image-attribution"]} </span>
        )}
      </div>
    </div>
  );
};

BlogStoryHeader.propTypes = {
  story: object
};

export default BlogStoryHeader;
